// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_return/complete_purchase_return.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { CreditNoteInfo } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.CompletePurchaseReturnRequest
 */
export class CompletePurchaseReturnRequest extends Message<CompletePurchaseReturnRequest> {
  /**
   * ID of the purchase return to be completed
   *
   * @generated from field: string purchase_return_id = 1;
   */
  purchaseReturnId = "";

  /**
   * Indicates if a credit note has been issued for the purchase return
   *
   * @generated from field: bool is_credit_note_issued = 2;
   */
  isCreditNoteIssued = false;

  /**
   * Information about the credit note issued for the purchase return
   *
   * @generated from field: com.neulink.pharmacy.CreditNoteInfo credit_note_info = 3;
   */
  creditNoteInfo?: CreditNoteInfo;

  constructor(data?: PartialMessage<CompletePurchaseReturnRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CompletePurchaseReturnRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_return_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_credit_note_issued", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "credit_note_info", kind: "message", T: CreditNoteInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompletePurchaseReturnRequest {
    return new CompletePurchaseReturnRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompletePurchaseReturnRequest {
    return new CompletePurchaseReturnRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompletePurchaseReturnRequest {
    return new CompletePurchaseReturnRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CompletePurchaseReturnRequest | PlainMessage<CompletePurchaseReturnRequest> | undefined, b: CompletePurchaseReturnRequest | PlainMessage<CompletePurchaseReturnRequest> | undefined): boolean {
    return proto3.util.equals(CompletePurchaseReturnRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CompletePurchaseReturnResponse
 */
export class CompletePurchaseReturnResponse extends Message<CompletePurchaseReturnResponse> {
  constructor(data?: PartialMessage<CompletePurchaseReturnResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CompletePurchaseReturnResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompletePurchaseReturnResponse {
    return new CompletePurchaseReturnResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompletePurchaseReturnResponse {
    return new CompletePurchaseReturnResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompletePurchaseReturnResponse {
    return new CompletePurchaseReturnResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CompletePurchaseReturnResponse | PlainMessage<CompletePurchaseReturnResponse> | undefined, b: CompletePurchaseReturnResponse | PlainMessage<CompletePurchaseReturnResponse> | undefined): boolean {
    return proto3.util.equals(CompletePurchaseReturnResponse, a, b);
  }
}

